export default __webpack_public_path__ + "static/media/flowQ.6b55d702.png";